import { get } from "@common/services/request";

export function getBeerstyles() {
  return get("v1/styles/");
}
